// The cookie question asked a second time, just above a booking's send button
// (owner, 2026-10-01: option B). Since the banner went live on 2026-09-30 most
// phone visitors scroll past it without answering, and an unanswered banner
// counts as "no": no Google Ads conversion, no click id on the booking, no
// Clarity. A guest about to book is the one visitor whose answer matters most.
//
// Shown only to a guest who has not answered either way, so a "no" on the
// banner is never asked again. The two answers carry the same weight, as the
// banner's do. Answering here writes the same stored choice as the banner,
// which starts or skips the trackers and hides the banner.
//
// Rendered by @majourneys/booking through the provider's `ConsentPrompt`
// slot, and directly by the bucket and stay checkouts.
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { onAnalyticsConsent, readAnalyticsConsent, writeAnalyticsConsent } from "./analytics-consent";

export function BookingConsentAsk() {
  // The page language from i18n rather than the router: this renders inside
  // the booking package's pages, and the i18n language follows the URL.
  const { t, i18n } = useTranslation();
  // Unknown until mounted: the stored choice lives in the browser, and the
  // server-rendered HTML must match the first client render.
  const [unanswered, setUnanswered] = useState(false);

  useEffect(() => {
    setUnanswered(readAnalyticsConsent() === null);
    return onAnalyticsConsent(() => setUnanswered(false));
  }, []);

  if (!unanswered) return null;

  const button =
    "inline-flex min-h-9 flex-1 items-center justify-center rounded-full border border-[rgba(17,14,57,0.16)] bg-white px-3 py-1.5 font-sans text-[12.5px] font-semibold text-[#110E39] transition hover:bg-[#F3F1FA]";

  return (
    <div
      role="group"
      aria-label={t("cookie_banner.notice_label")}
      className="rounded-2xl border border-[rgba(17,14,57,0.12)] bg-[#F7F6FB] px-3.5 py-3 text-start"
    >
      <p className="font-sans text-[12.5px] leading-[18px] text-[#5a5d77]">
        {t("cookie_ask.message")}{" "}
        <a
          href={`/${i18n.language || "en"}/cookie-policy`}
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold text-[#110E39] underline underline-offset-2"
        >
          {t("cookie_banner.learn_more")}
        </a>
      </p>
      <div className="mt-2.5 flex gap-2">
        <button type="button" onClick={() => writeAnalyticsConsent("denied")} className={button}>
          {t("cookie_ask.decline")}
        </button>
        <button type="button" onClick={() => writeAnalyticsConsent("granted")} className={button}>
          {t("cookie_ask.accept")}
        </button>
      </div>
    </div>
  );
}
